import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  makeIsTopSalesEmpty,
  makeTopSalesDataByKey,
} from '../../../../redux/selectors/topSalesSelector';
import TopSalesListTitle from './TopSalesListTitle';

const mapStateToProps = () => {
  const selector = createStructuredSelector({
    isFetching: makeTopSalesDataByKey('isFetching'),
    isTopSalesEmpty: makeIsTopSalesEmpty(),
  });

  return state => selector(state);
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TopSalesListTitle);
